import produce from 'immer';
import create from 'zustand';
import moment from 'moment-timezone';
import { TZ } from '../../../../shared/consts';
import { INPUT_FMT } from '../../common/constants';

const filterByContributorAndDate = (contributors, daysAgo) => {
  const selectedSlug = contributors.filter(c => c.selected).map(c => c.slug);
  // in the case of Infinity, the earliest still valid for comparison to yield
  // false result
  const earliest = moment.tz(TZ).startOf('day').subtract(2 * daysAgo - 1, 'days');
  return evt => (
    selectedSlug.indexOf(evt.c) >= 0
    // use negative of isSameOrBefore instead of isAfter to cope with Infinity
    && !moment.tz(evt.date, INPUT_FMT, TZ).isSameOrBefore(earliest, 'day')
  );
};

const setEvents = (rawEvents, daysAgo, contributors) => {
  if (!Number.isFinite(daysAgo) && contributors.every(c => c.selected)) {
    return [...rawEvents];
  }
  return rawEvents.filter(filterByContributorAndDate(contributors, daysAgo));
};

const useInvestorTypesStore = create(set => ({
  requestData: false,
  loading: false,
  /**
   * rawEvents and events have the following structure:
   * [
   *   {
   *     it: number,
   *     c: string,
   *     date: string,
   *     count: number
   *   }
   *   ...
   * ]
   */
  rawEvents: [],
  events: [],
  daysAgo: Infinity,
  generatedAt: moment(),
  contributors: [],
  set: fn => set(produce(fn)),
  setRawEvents: d => set(state => {
    const rawEvents = d || [];
    const events = setEvents(rawEvents, state.daysAgo, state.contributors);
    return { rawEvents, events };
  }),
  setDaysAgo: d => set(state => ({
    daysAgo: d,
    events: setEvents(state.rawEvents, d, state.contributors),
  })),
  setContributors: d => set(state => ({
    contributors: d || [],
    events: setEvents(state.rawEvents, state.daysAgo, d || []),
  })),
}));

export default useInvestorTypesStore;
